import { useEffect, useState } from "react";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="relative bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-400 text-primary-900">
                <i className="ri-play-mini-fill text-xl leading-none"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">吃瓜视频</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-7 text-background-200/80">
              专注娱乐八卦的瓜料分类聚合站，覆盖娱乐八卦、明星爆料、社会事件、网红日常、搞笑合集与实拍现场，
              分类清晰、更新及时，让你吃瓜不迷路。
            </p>
            <div className="mt-5 flex items-center gap-2 text-background-200/80">
              <i className="ri-mail-line"></i>
              <span className="text-sm">contact@chigua-video.example</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { id: "hotlist", label: "今日热榜" },
                { id: "category", label: "分类找瓜" },
                { id: "focus", label: "焦点瓜料" },
                { id: "stream", label: "视频速递" },
                { id: "faq", label: "常见问题" },
              ].map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-background-200/80 transition-colors hover:text-accent-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">内容分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <a href={`#stream`} className="text-background-200/80 transition-colors hover:text-accent-300">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">关于平台</h4>
            <p className="mt-4 text-sm leading-7 text-background-200/80">
              吃瓜视频致力于把散落在全网的热门瓜料做分类整理与客观呈现，坚持理性吃瓜、
              审慎核实，不渲染未经证实的猜测，为网友提供更干净、高效的内容环境。
            </p>
            <div className="mt-4 flex flex-wrap gap-2 text-xs">
              {["免责声明", "内容准则", "意见反馈"].map((t) => (
                <span key={t} className="cursor-pointer rounded-full bg-primary-800 px-3 py-1.5 text-background-200/80 transition-colors hover:bg-primary-700">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/15 pt-6 text-xs text-background-200/60 sm:flex-row">
          <p>© {new Date().getFullYear()} 吃瓜视频 · 仅供娱乐参考，请理性看待网络信息</p>
          <p className="flex items-center gap-2">
            吃瓜不迷路 · 全网热点一网打尽
            <i className="ri-heart-fill text-accent-400"></i>
          </p>
        </div>
      </div>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="回到顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-accent-400 text-primary-900 shadow-soft transition-all hover:bg-accent-300 ${showTop ? "opacity-100" : "pointer-events-none opacity-0"}`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </footer>
  );
}